import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

const VerificationModal = ({ redirectUrl, returnUrl, onComplete, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);
  const iframeRef = useRef(null);
  const trustedOrigin = new URL(redirectUrl).origin;

  const handleIframeLoad = () => {
    setIsLoading(false); // Hide loader once iframe loads
    // setTimeout(function () {
    // }, 2000);
  };
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === "return-url-loading") {
        setIsLoading(true); // Set state before full load
        onComplete();
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [onComplete]);

  return (
    <>
      {isLoading && (
        <>
          <div>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
        </>
      )}
      <Box sx={{ marginBottom: "-3px" }}>
        <iframe
          onLoad={handleIframeLoad}
          ref={iframeRef}
          src={redirectUrl}
          title="3DS Verification"
          width="100%"
          height="600px"
          style={{
            border: "none",
            backgroundColor: "#2d2d2d",
            borderRadius: "5px",
          }}
        />
      </Box>
    </>
  );
};

export default VerificationModal;
